<script>
import setting from '@/setting.js'

export default {
    name: "SeasonPicker",
    data() {
        const nowDate = new Date()
        let year = nowDate.getFullYear()
        const OPENING_GAME = new Date(nowDate.getFullYear(), 2, 2)
        // 開幕日以前だったら去年までのデータを出す
        if (new Date() <= OPENING_GAME) {
            year = year - 1
        }
        return {
            start_year: setting.startYear,
            year,
            from_month: 1,
            to_month: 12,
        }
    },
    computed: {
        listOfMonth () {
            let listOfMonth = []
            let i = 1, l = 12
            for (; i <= l; i++) {
                listOfMonth.push(
                    {
                        text: i + '月',
                        value: i
                    }
                )
            }
            return listOfMonth
        },
        listOfYears () {
            let listOfYears = []
            if (this.gameList) {
                for (const year in this.gameList) {
                    if (/[0-9]{4}/.test(year) && Array.isArray(this.gameList[year])) {
                        listOfYears.push({
                            text: year,
                            value: year
                        })
                    }
                }
                listOfYears.sort().reverse()
                return listOfYears
            }
            const nowDate = new Date()
            for (let year = nowDate.getFullYear(), min = this.start_year; year >= min; year--) {
                listOfYears.push({
                    text: year,
                    value: year
                })
            }
            return listOfYears
        }
    },
    methods: {
        existsPlayer (year, team, player) {
            // 該当年度に在籍中の選手のみ出力
            if (player.additional && player.additional.search_career) {
                if (player.additional.search_career[year]) {
                    let teams = player.additional.search_career[year]
                    if (teams.length > 0) {
                        return teams.includes(team)
                    }
                    return false
                } else {
                    return false
                }
            }
            return false
        },
        playerHistory (year, team, player) {
            // チーム在籍時のプロフィール取得,無ければ空
            let history = {}
            let inputDate = new Date(year, 0, 1)
            if (!player.additional.career_history) {
                return {}
            }
            player.additional.career_history.forEach((row) => {
                let join_date = new Date(row.join_year, row.join_month - 1, 1)
                let leave_date = new Date(row.leave_year, row.leave_month, 0)
                if (row.team === team && join_date <= inputDate && inputDate <= leave_date) {
                    history = row
                    return true
                }
            })
            return history
        },
        joinDate (year, month) {
            // 検索用入団日(基本は月初)
            return window.moment([year, month - 1, 1])
        },
        leaveDate (year, month) {
            // 検索用退団日(基本は月末)
            return window.moment([year, month - 1, 1]).endOf('month')
        }
    }
}
</script>

<style>
/* ラジオボタン、チェックボックスのスタイル変更 */
.btnContainer {
    display: inline-block;
}

.btnContainer input[type="radio"],
.btnContainer input[type=checkbox] {
    display: none;
}

.btnContainer label {
    display: inline-block;
    height: 20px;
    padding: 7px 8px 0;
    margin-left: 10px;
    font-size: 1.3rem;
    text-align: center;
    background: #fff;
    border-radius: 20px;
    border: 2px solid #6a8fdb;
    font-weight: bold;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.btnContainer:first-child label {
    margin-left: 0;
}

.btnContainer input[type="radio"]:checked + label,
.btnContainer input[type="checkbox"]:checked + label {
    background: #3c5992;
    border: 2px solid #3c5992;
    color: #fff;
    cursor: default;
}
</style>
